import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Select, Row, Upload, Radio, Tooltip } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'
import { APPS ,LANG } from '../../../utils/constants'
import { selectRule } from '../../../utils/rules'

const PDPAForm = (props) => {
  const { visible, onOk, onCancel, formData, form, } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        app: formData.app,
        detail: formData.detail,
        lang: formData.lang,
      })
    }
    return () => {
      form.resetFields()
    }
  }, [formData])


  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          app: values.app,
          detail: values.detail,
          lang: values.lang,
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a PDPA`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Form.Item label="App">
          {getFieldDecorator(`app`, { ...selectRule })(
            <Select>
              {APPS.map((app) => {
                return (
                  <Select.Option key={app}>{app}</Select.Option>
                )
              })}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="Detail">
          {getFieldDecorator(`detail`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input.TextArea rows={10}
            name="detail"
            placeholder="detail" />)}
        </Form.Item>
        <Form.Item label="Language">
          {getFieldDecorator(`lang`, { ...selectRule })(
            <Select>
              {LANG.map((app) => {
                return (
                  <Select.Option key={app}>{app}</Select.Option>
                )
              })}
            </Select>
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPDPAForm = Form.create({ name: 'PDPAForm' })(
  PDPAForm
)
export default WrappedPDPAForm
